import { GrainElevatorAssessmentInfoState } from "../../../types/assessment_info/GrainElevatorAssessmentInfoState"
import { BusinessOperationsData } from "../../../types/assessment_info/gev/BusinessOperationsData"
import { GET_ASSESSMENT_INFO, RESET_GET_ASSESSMENT_INFO } from "../../actionTypes/actionsTypes"
import defaultAsyncReducer from "../../defaultReducer"
import { AppAction, LocalAction } from "../../types"

const initialState: GrainElevatorAssessmentInfoState = {
  loading: false,
  success: false,
  error: false,
  message: "",
  formData: {} as BusinessOperationsData,
}

function getGrainElevatorAssessmentInfoReducer(state = initialState, action: AppAction | LocalAction) {
  if (action.type === RESET_GET_ASSESSMENT_INFO) {
    return initialState
  } else {
    return defaultAsyncReducer(state, action as AppAction, GET_ASSESSMENT_INFO)
  }
}

export default getGrainElevatorAssessmentInfoReducer